<form [formGroup]="formName">
    @if (this.isFilter) {
        <p-calendar class="date-filter" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" dateFormat="dd/mm/yy" [showIcon]="true" [placeholder]="placeholder"
            [minDate]="minDate" [maxDate]="maxDate" appendTo="body"></p-calendar>
    } @else {
        <p-calendar [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [dateFormat]="dateFormat" [showIcon]="true" [placeholder]="placeholder"
            [minDate]="minDate" [maxDate]="maxDate" appendTo="body"></p-calendar>
    }
</form>
